import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dt-credential-form"
export default class extends Controller {
  static targets = ["passwordField", "buttonHandlePassword", "encryptedPasswordField"]


  connect() {
  }

  toggleEditPassword() {
    if (!this.hasPasswordFieldTarget || !this.hasButtonHandlePasswordTarget) return

    this.passwordFieldTarget.removeAttribute('disabled')
    this.passwordFieldTarget.value = ''
    this.passwordFieldTarget.focus()
    this.buttonHandlePasswordTarget.setAttribute('disabled', true)

    if (this.hasEncryptedPasswordFieldTarget) {
      this.encryptedPasswordFieldTarget.setAttribute('disabled', true)
    }
  }
}
